import { render, staticRenderFns } from "./ProductsTable.vue?vue&type=template&id=b5b08564&scoped=true&"
import script from "./ProductsTable.vue?vue&type=script&lang=ts&"
export * from "./ProductsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsTable.vue?vue&type=style&index=0&id=b5b08564&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b08564",
  null
  
)

export default component.exports